export const userRoles = ['viewer', 'editor', 'manager', 'administrator'] as const;
export type UserRole = typeof userRoles[number];

export interface UserAuth {
  id: string,
  email: string,
  role: UserRole,
  isAdministrator: boolean,
  isManager: boolean,
  isEditor: boolean,
  isViewer: boolean,
  group: string | null,
  zoneId: string | null,
  zone: {
    id: string,
    name: string
  } | null,
  homeLocationId: string | null,
  homeLocation: {
    id: string,
    name: string
  } | null
}
